export default {
  issueType: 'RegS',
  classificationSelected: 'Industry Group (L2)',
  initialising: false,
}
